/*
  Uses the `?signed_out=true` query param set during sign out to reset the Segment and Posthog analytics.
*/

import { analytics } from "../analytics";
import { devlog } from "../utils";

const SegmentResetHook = {
  mounted() {
    queryParams = new URLSearchParams(window.location.search);
    isSignedOut = queryParams.get("signed_out") === "true";
    if (isSignedOut) {
      devlog("resetting analytics");
      analytics.reset();
    }
  },
};

export default SegmentResetHook;
